/* EN-TÊTE « SIGNATURE » (2026-10-14) — comportements : version compacte au défilement, menu téléphone,
   « Réserver ma séance » vers le formulaire de la page, numéro copiable sur PC. */
(function () {
  var header = document.querySelector('[data-plmh]');
  if (!header) return;
  var drawer = header.querySelector('[data-plmh-drawer]');
  var burger = header.querySelector('[data-plmh-burger]');
  var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

  // Version compacte dès qu'on descend un peu.
  var compact = false;
  function onScroll() {
    var c = window.scrollY > 40;
    if (c !== compact) { compact = c; header.classList.toggle('is-compact', c); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Menu téléphone.
  function setOpen(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    header.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('plmh-lock', open);
    if (burger) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    }
  }
  if (burger) burger.addEventListener('click', function () { setOpen(drawer.hidden); });
  if (drawer) drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
  window.addEventListener('resize', function () { if (!isPhone()) setOpen(false); });

  // « Réserver ma séance » : formulaire de la page courante, sinon page Contact.
  function formTarget() { return document.querySelector('.prestation-contact, .shared-contact'); }
  function goToForm(smooth) {
    var t = formTarget();
    if (!t) return false;
    var top = t.getBoundingClientRect().top + window.scrollY - (isPhone() ? 74 : 84);
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    var first = t.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, smooth ? 650 : 50);
    return true;
  }
  header.querySelectorAll('[data-plmh-book]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      setOpen(false);
      if (goToForm(true)) e.preventDefault();
    });
  });
  if (location.hash === '#demande') {
    window.addEventListener('load', function () { setTimeout(function () { goToForm(true); }, 150); });
  }

  // Téléphone de la bande du haut : sur PC, un clic copie le numéro (pas d'appel depuis un ordinateur) ;
  // sur téléphone, appel direct.
  var callLink = header.querySelector('[data-plmh-call]');
  if (callLink) callLink.addEventListener('click', function (e) {
    if (isPhone()) return;
    e.preventDefault();
    var n = callLink.getAttribute('data-plmh-number') || '';
    var label = callLink.querySelector('span');
    var done = function () {
      callLink.classList.add('is-copied');
      if (label) label.textContent = 'Numéro copié ✓';
      setTimeout(function () { callLink.classList.remove('is-copied'); if (label) label.textContent = n; }, 1800);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(n).then(done, done); else done();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
})();
